

import { Button, Checkbox, Container, Form, FormField, Grid, Input, Link, Multiselect, SelectProps, Table, TokenGroup, TokenGroupProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;

//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { MenuItem } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';


type ItemGroupType = {

    idGroupType: number;
    bookingDeleteTime: number;
    bookAheadTime: number;
    bookingMaxGroup: number;
    maxBookingTime: number;
    isActiveGroupType: number;
    hasPax: number;
    groupTypeMasterCodeMaxBookings: number;
    groupType: string;
    groupTypeMaster: string;
    groupTypeMasterCode: string;
    showOnBooking: number;
    showOnFlightLog: number;
    groupBookingUnlimited: number;
    minBookHour: number;
    maxBookHour: number;
    equipments: number;
    thresholdBefore: number;
    thresholdAfter: number;
    jsonConfigEquipment: any;
    idBookingTypes: number[];
    notifications: number[];
}
export const MasterEquipmentsGroupsPage = () => {
    const { data, menu } = useGlobalState();

    const [showGroup, setShowGroup] = useState(false);



    const [groupType, setGroupType] = useState<ItemGroupType>()
    const [groupTypes, setGroupTypes] = useState<ItemGroupType[]>([])

    const [menus, setMenus] = useState<MenuItem[]>([]);
    const [idGroupType, setIdGroupType] = useState<number>(0);

    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) {
                setGroupType(undefined)
                handleGetGroupDetail(parseInt(id))
            } else {
                setGroupType(undefined)
                handleGetGroups();
            }
            setIdGroupType(id ? parseInt(id) : 0);
            if (!id) setGroupType(undefined)
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    const handleGetGroupDetail = async (idGroupType: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/groupstypes/grouptype',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ idGroupType: idGroupType })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.groupType) {

                setGroupType(data.groupType)
                //setMenus(data.menus)
                setShowGroup(true)
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetGroups = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/groupstypes/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({ columns: "*" })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.groupTypes)
                setGroupTypes(data.groupTypes)
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveGroupType = async () => {
        addNotification(data.status, "error", setData);
        try {
            let body = {
                idGroupType: groupType?.idGroupType,
                groupType: groupType?.groupType,
                isActiveGroupType: groupType?.isActiveGroupType,
                bookingDeleteTime: groupType?.bookingDeleteTime,
                bookAheadTime: groupType?.bookAheadTime,
                bookingMaxGroup: groupType?.bookingMaxGroup,
                groupTypeMaster: groupType?.groupTypeMaster,
                groupTypeMasterCodeMaxBookings: groupType?.groupTypeMasterCodeMaxBookings,
                maxBookingTime: groupType?.maxBookingTime,
                minBookHour: groupType?.minBookHour,
                maxBookHour: groupType?.maxBookHour,
                showOnBooking: groupType?.showOnBooking,
                showOnFlightLog: groupType?.showOnFlightLog,
                groupBookingUnlimited: groupType?.groupBookingUnlimited,
                idBookingTypes: groupType?.idBookingTypes,
                jsonConfigEquipment: { notifications: groupType?.notifications, hasPax: groupType?.jsonConfigEquipment?.hasPax, description: "" }
            }

            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/groupstypes/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify(body)
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code === 0) {
                setGroupType(undefined)
                window.location.hash = "#masters/equipments/groups"

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false)
        }
    };
    useEffect(() => {
        //handleGetGroups()

    }, []);

    //setIdGroupType(item.idGroupType)


    type NotificationToken = TokenGroupProps.Item & { idUser: number };

    const [notificationItemsState, setNotificationItemsState] = useState<NotificationToken[]>([]);
    useEffect(() => {
        if (groupType?.notifications?.length) {
            setNotificationItemsState(
                groupType.notifications.map(id => ({
                    label: getUser(id, data)?.displayName || "Unknown",
                    dismissLabel: `Remove ${id}`,
                    idUser: id,
                }))
            );
        }
    }, [groupType, data]);
    useEffect(() => {
        //console.log(notificationItemsState)

    }, [notificationItemsState]);

    // When group.jsonMenu arrives, update checkedItems

    // map your objects to Multiselect options
    type OptionDefinition = SelectProps.Option;


    const bookingTypeOptions = data.bookingTypes.map((bt: { bookingType: any; idBookingType: { toString: () => any; }; }) => ({
        label: bt.bookingType,           // what the user sees
        value: bt.idBookingType.toString() // must be string
    }));
    const preselected = bookingTypeOptions.filter((opt: { value: any; }) =>
        groupType?.idBookingTypes.includes(Number(opt.value))
    );
    const [selectedBookingTypes, setSelectedBookingTypes] = useState<OptionDefinition[]>(preselected);

    return (
        <CustomAppLayout
            toolsHide


            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween direction='vertical' size="l">
                    {!!groupType && (
                        <Form actions={
                            <SpaceBetween direction="horizontal" size="l">
                                <Button variant="primary" onClick={handleSaveGroupType}>
                                    Guardar
                                </Button>
                            </SpaceBetween>
                        }
                            header={
                                <Header
                                    actions={

                                        <Button variant="link" onClick={() => window.location.hash = "#masters/equipments/groups"}>
                                            Cancelar
                                        </Button>
                                    }
                                    variant="h2"
                                    description={`ID ${groupType?.idGroupType}`}>
                                    Detalle del grupo <em>{groupType?.groupType}</em>
                                </Header>}
                        >

                            <Container>
                                <SpaceBetween direction='vertical' size='xs'>
                                    <Grid gridDefinition={[{ colspan: 6 }, { colspan: 3 }, { colspan: 3 }]}>
                                        <div>
                                            <FormField label={"Glosa"}>
                                                <Input value={groupType?.groupType || ""}
                                                    onChange={(detail) => {
                                                        //console.log(detail.detail.value)
                                                    }}
                                                />
                                            </FormField>
                                        </div>
                                        <div>
                                            <FormField label={"Etqiueta"}>
                                                <Input value={groupType?.groupTypeMaster || ""}
                                                    onChange={(detail) => {
                                                        //console.log(detail.detail.value)
                                                    }} />
                                            </FormField>
                                        </div>

                                    </Grid>
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <div style={{ width: 150 }}>
                                            <FormField label="Estado del grupo">
                                                <Checkbox checked={groupType?.isActiveGroupType === 1} onChange={(event) => {
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, isActiveGroupType: event.detail.checked ? 1 : 0 } : prev
                                                    );
                                                }}>
                                                    Activo
                                                </Checkbox>
                                            </FormField>
                                        </div>
                                        <div style={{ width: 250 }}>
                                            <FormField label="Reservas ilimitadas" constraintText="Define si el grupo de aeronaves se le permite reservar mas de una reserva en conflicto">
                                                <Checkbox checked={groupType?.groupBookingUnlimited === 1} onChange={(event) => {
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, groupBookingUnlimited: event.detail.checked ? 1 : 0 } : prev
                                                    );
                                                }}>
                                                    Activo
                                                </Checkbox>
                                            </FormField>
                                        </div>
                                        <div style={{ width: 250 }}>
                                            <FormField label="PAX" constraintText="Grupo habilitado para contabilizar PAX en reservas">
                                                <Checkbox checked={groupType?.jsonConfigEquipment?.hasPax} onChange={(event) => {
                                                    setGroupType((prev) => {
                                                        if (!prev) return prev;

                                                        return {
                                                            ...prev,
                                                            jsonConfigEquipment: {
                                                                ...prev.jsonConfigEquipment, // Spread the existing nested object
                                                                hasPax: event.detail.checked // Update the specific nested property
                                                            }
                                                        };
                                                    });

                                                }}>
                                                    Activo
                                                </Checkbox>
                                            </FormField>
                                        </div>

                                    </SpaceBetween>
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Tº max. reserva" constraintText="Extensión máxima de una reserva">
                                                <Input type="number" value={groupType?.maxBookingTime.toString() || "12"} onChange={(event) => {

                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, maxBookingTime: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Umbral eliminación" constraintText="Cuantas horas antes puede ser una reserva eliminada">
                                                <Input type='number' value={groupType?.bookingDeleteTime.toString() || "1"} onChange={(event) => {

                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, bookingDeleteTime: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Umbral reserva" constraintText="Cuantas horas antes puede ser generada una reserva">
                                                <Input type='number' value={groupType?.bookAheadTime.toString() || "1"} onChange={(event) => {

                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, bookAheadTime: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 200 }}>

                                            <FormField label="Reservas simultáneas" constraintText="Cuantas reservas pueden ser generadas en superposición">
                                                <Input type='number' value={groupType?.bookingMaxGroup.toString() || "1"} onChange={(event) => {

                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, bookingMaxGroup: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>

                                    </SpaceBetween>
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Inicio" constraintText="Hora desde la cual se puede reservar">
                                                <Input type="number" value={groupType?.minBookHour.toString() || "9"} onChange={(event) => {
                                                    let value = parseInt(event.detail.value)
                                                    if (isNaN(value) || value < 0 || value > 24)
                                                        value = 9
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, minBookHour: value } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 200 }}>
                                            <FormField label="Termino" constraintText="Hora hasta la cual se puede reservar">
                                                <Input type='number' value={groupType?.maxBookHour.toString() || "20"} onChange={(event) => {
                                                    let value = parseInt(event.detail.value)
                                                    if (isNaN(value) || value < 0 || value > 24)
                                                        value = 20
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, maxBookHour: value } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>

                                    </SpaceBetween>


                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <div style={{ width: 250 }}>
                                            <FormField label="Umbral prevuelo" constraintText="Horas antes del vuelo para considerar como prevuelo">
                                                <Input type="number" value={groupType?.thresholdBefore.toString() || "1"} onChange={(event) => {
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, thresholdBefore: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 250 }}>
                                            <FormField label="Umbral postvuelo" constraintText="Horas despues del vuelo para considerar como postvuelo">
                                                <Input type="number" value={groupType?.thresholdAfter.toString() || "1"} onChange={(event) => {
                                                    setGroupType((prev) =>
                                                        prev ? { ...prev, thresholdAfter: Number(event.detail.value) } : prev
                                                    );
                                                }} />
                                            </FormField>
                                        </div>

                                    </SpaceBetween>

                                    <SpaceBetween direction='horizontal' size='xs'>
                                        <div style={{ width: 400 }}>
                                            <FormField label="Tipos de reserva" constraintText="En cuales tipos de reserva se despliegan para este grupo al momento de reservar">
                                                <Multiselect
                                                    selectedOptions={preselected}
                                                    onChange={({ detail }) => {
                                                        const options = [...detail.selectedOptions]; // copy out of readonly
                                                        setSelectedBookingTypes(options);
                                                        setGroupType((prev) =>
                                                            prev
                                                                ? { ...prev, idBookingTypes: options.map((opt) => Number(opt.value)), } : prev
                                                        );

                                                    }}
                                                    options={bookingTypeOptions}
                                                    placeholder="Seleccione tipos de reserva"
                                                />
                                            </FormField>
                                        </div>
                                        <div style={{ width: 400 }}>
                                            <FormField label="Notificaciones" constraintText="Usuarios a los cuales se les notifica cuando se genera una reserva">
                                                <SelectUser
                                                    onConfirm={(detail) => {
                                                        if (detail) {
                                                            setNotificationItemsState((prev) => {
                                                                // prevent duplicates
                                                                if (prev.some((item) => item.label === detail.displayName)) {
                                                                    return prev;
                                                                }

                                                                // update groupType.notifications
                                                                setGroupType((prevGroup) => {
                                                                    if (!prevGroup) return prevGroup;

                                                                    const notifications = prevGroup.notifications.includes(detail.idUser)
                                                                        ? prevGroup.notifications
                                                                        : [...prevGroup.notifications, detail.idUser];

                                                                    return { ...prevGroup, notifications };
                                                                });

                                                                // append new token with idUser included
                                                                return [
                                                                    ...prev,
                                                                    {
                                                                        label: detail.displayName,
                                                                        dismissLabel: `Remove ${detail.idUser}`,
                                                                        idUser: detail.idUser, // ✅ include this
                                                                    } as NotificationToken,
                                                                ];
                                                            });
                                                        }
                                                    }}
                                                />
                                                <TokenGroup
                                                    items={notificationItemsState}
                                                    onDismiss={({ detail }) => {
                                                        const index = detail.itemIndex;
                                                        const idToRemove = notificationItemsState[index].idUser;

                                                        setNotificationItemsState(prev => prev.filter((_, i) => i !== index));

                                                        if (idToRemove !== undefined) {
                                                            setGroupType(prev => prev
                                                                ? { ...prev, notifications: prev.notifications.filter(id => id !== idToRemove) }
                                                                : prev
                                                            );
                                                        }
                                                    }}
                                                />

                                            </FormField>
                                        </div>
                                    </SpaceBetween>
                                </SpaceBetween>
                            </Container>
                        </Form>
                    )}
                    {
                        !groupType && (
                            <SpaceBetween direction="vertical" size="xs">

                                <Header actions={<Favorites />}>Grupos de material</Header>
                                <Table
                                    variant="embedded"

                                    columnDefinitions={[
                                        {
                                            id: "groups",
                                            header: "Grupo",
                                            cell: item => <Link href={`#masters/equipments/groups?id=${item.idGroupType}`}>{item.groupType}</Link>,
                                        },
                                        {
                                            id: "groupCode",
                                            header: "Código",
                                            cell: item => item.groupTypeMaster,
                                        },
                                        {
                                            id: "equipments",
                                            header: "Equipos",
                                            cell: item => item.equipments,
                                        },
                                        {
                                            id: "isActiveGroupType",
                                            header: "",
                                            width: 100,
                                            cell: item => {
                                                if (item?.isActiveGroupType === 0)
                                                    return (<BadgeCustom color="red">Inactivo</BadgeCustom>)
                                            },
                                        },
                                    ]}
                                    items={groupTypes ?? []}
                                />
                            </SpaceBetween>
                        )
                    }
                </SpaceBetween >
            }

        />
    );
};


